import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { shopCartIconReducer } from './shop-cart-icon.reducer';
import { ShopCartIconEffects } from './shop-cart-icon.effects';

@NgModule({
    imports: [StoreModule.forFeature('cartIcon', shopCartIconReducer), EffectsModule.forFeature([ShopCartIconEffects])],
})
export class ShopCartIconModule {}
